export default __webpack_public_path__ + "templates/index.html";